const { REACT_APP_CONTENTS_URL, REACT_APP_CONTENTS_TOKEN } = process.env;

export const promotionPopupApi = () => {
  return {
    headers: {
      emquest_access_token: REACT_APP_CONTENTS_TOKEN,
    },
    apiUrl: REACT_APP_CONTENTS_URL + `/popup`,
  };
};
